module.exports = __webpack_public_path__ + "static/img/c_img_5.a62b79b2.png";